import React from 'react'
import PropTypes from 'prop-types'
import TextField from './../TextField'
import Button from './../../Button'
import styles from './Stepper.scss'

export default function Stepper(props) {
  const increase = () => {
    props.onChange({ target: { id: props.id, value: parseInt(props.value) + 1 } })
  }

  const decrease = () => {
    props.onChange({ target: { id: props.id, value: parseInt(props.value) - 1 } })
  }

  const onChange = event => {
    const { value } = event.target
    let newValue = value
    if (isNaN(parseInt(value)) || parseInt(value) < (props.min || 0)) {
      newValue = props.min || 0
    }
    props.onChange({ target: { id: props.id, value: newValue } })
  }

  const onFocus = event => {
    event.target.select()
  }

  const onMouseUp = event => {
    event.preventDefault()
  }

  const { min, value, max, id, ...rest } = props
  return (
    <div className={styles.Stepper}>
      <Button primary disabled={min == value} onClick={() => decrease()}>
        -
      </Button>
      <TextField
        value={value}
        onFocus={onFocus}
        onMouseUp={onMouseUp}
        id={id}
        className={styles.Input}
        {...rest}
        onChange={onChange}
      />
      <Button primary disabled={max == value} onClick={() => increase()}>
        +
      </Button>
    </div>
  )
}

Stepper.propTypes = {
  value: PropTypes.any,
  id: PropTypes.string,
  step: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/Form/Stepper/index.js